export const MOUNT_SELECTOR = '.vue-lpu-services-mount'
export const QUERY_PARAM_PAGE = 'page'

export const DATA_QA = {
  component: 'lpu_services',
  search: 'lpu_services_search', // компонент поиска/фильтрации
  pagination: 'lpu_services_pagination', // компонент пагинации
  serviceDateUpdated: 'lpu_services_service_date_updated_text',
  serviceList: 'lpu_services_service_list', // в django-шаблоне будет использоваться lpu_services_initial_service_list
  serviceGroup: 'lpu_services_service_group',
  serviceClassName: 'lpu_services_service_class_name_text',
  service: 'lpu_services_service',
  serviceName: 'lpu_services_service_name_text',
  servicePriceFullButton: 'lpu_services_service_price_full_button', // цена будет в виде кнопки, если на услугу есть запись
  servicePriceFull: 'lpu_services_service_price_full_text', // цена будет в виде обычного текста, если на услугу нет записи
  serviceNotFound: 'lpu_services_service_not_found',
  serviceDuration: 'lpu_services_service_duration',
  schedule: 'lpu_services_service_price_schedule',
  toggleCalendar: 'lpu_services_service_price_toggle_calendar',
  switchOnlineAppointment: 'lpu_services_filter_online',
  buttonShowAll: 'lpu_services_service_price_show_all',
}

export const YANDEX_GOALS = {
  visitPage: 'lpu_services__visit_page', // посетили страницу с услугами клиники
  useSearch: 'lpu_services__use_search', // воспользовались поисковой строкой (в том числе фильтрацией)
  clickServicePriceButton: 'lpu_services__click_service_price_button', // нажали на кнопку с ценой услуги (происходит редирект на страницу записи на услугу)
}

export const PAGINATION_CONTAINER_SELECTOR = '.lpu-services-pagination-container'

export const DATE_UPDATED_COLOR_PALETTE_DATA = [
  ['', 'text-info--text'],
  ['bg-success', 'text-success--text'],
  ['bg-warning', 'text-warning--text'],
  ['bg-error', 'text-error--text'],
]

export const DATE_UPDATED_TEXT_DATA = date => [
  `Обновлено ${date}`,
  `Обновлено клиникой ${date}`,
  `Обновлено клиникой ${date}. Цены могли устареть`,
  `Обновлено клиникой ${date}. Цены устарели`,
]

export const LPU_SERVICES_EVENTS = {
  switchOnline: 'lpu-services:switch-online',
}
